import apiFetcher, { apiFetcherArgs } from '@/api/apiFetcher';
import { DEFAULT_NETWORK } from '@/constants';
import useSWR from 'swr';

export default function useApi<T>(
  args: apiFetcherArgs
): [T | undefined, Error | undefined] {
  const network = DEFAULT_NETWORK;
  args.queryParams = { ...args.queryParams, network: network };

  const { data, error } = useSWR<T, Error, apiFetcherArgs>(args, apiFetcher);

  return [data, error];
}
